import initDrawer from "./initDrawer";
import initHeader from "./initHeader";
import initMegaMenu from "./initMegaMenu";
import initSmoothScroll from "./initSmoothScroll";
import initPageTop from "./initPageTop";
import initStickySidebar from "./initStickySidebar";
import initViewport from "./initViewport";

export default function initCommonScript() {
  // viewport固定
  initViewport();

  // headerコンテンツ
  initHeader();

  //メガメニュー
  initMegaMenu();

  // スムーススクロール
  initSmoothScroll();

  //ページトップへ戻る
  initPageTop();

  // ドロワーメニュー
  initDrawer();

  // 追従サイドバー
  initStickySidebar();
}
